'use client';

import { c as _c } from "react/compiler-runtime";
import ImageViverseLogoText from '@/public/images/viverse-logo-text.png';
import ImageViverseLogo from '@/public/images/viverse-logo.png';
import OptimizedImage from '@/components/OptimizedImage';
const ShimmerLogo = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <OptimizedImage src={ImageViverseLogo} alt="VIVERSE logo" width={90} height={78} className="mb-4.5" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col items-center justify-center">{t0}<OptimizedImage src={ImageViverseLogoText} alt="VIVERSE" width={150} height={20} style={{
        mask: "linear-gradient(-45deg, #000 30%, #0005, #000 70%) right/350% 100%",
        animation: "shimmer 1.4s infinite"
      }} /><style jsx={true} scoped={true}>{"\n          @keyframes shimmer {\n            100% {\n              mask-position: left;\n            }\n          }\n        "}</style></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default ShimmerLogo;